



























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {User} from "@/types";
import {AxiosError, AxiosResponse} from "axios";
import SubscribeBtn from "@/components/community/_subscribeBtn.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
//@ts-ignore
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'

@Component({
    components: {
        SubscribeBtn,
        Swiper,
        SwiperSlide,
        RangeSlider
    },
    computed: {...mapGetters(["user"])},
})
export default class Community extends Vue {
    postCnt: number = 0;
    community: any = {};
    bannerImg: string = "";
    profileImg = '';

    TMSswiperOption = {
        slidesPerView: 'auto',
        spaceBetween: '0.4%',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            300: {
                slidesPerView: 3.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 5.5
            },
            992: {
                slidesPerView: 7
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }

    unCommunityId: string = ''
    user !: any;

    mounted() {
        this.$store.dispatch("loginState")
            .then(() => {
                this.fetch();
            })

    }
    unsubscribe(communityId: string) {
        this.$modal.show('deleteConfirm')
        this.unCommunityId = communityId;
    }
    yesUnsubscribe() {
        this.$api.unsubscribe({user_id: this.user.id, community_id: this.unCommunityId})
            .then((res: any) => {
                this.fetch();
            })
            .catch((err: any) => {
                if (err.message) {
                    alert(err.message)
                }
            })
            .finally(() => {
                this.$modal.hide('deleteConfirm')
            })
    }

    fetch() {
        this.$api.communityInfo(this.$route.params.community_id)
            .then((res: any) => {
                this.community = res
                this.$store.commit('communityInfo', res);
                if (this.community.banner_img) {
                    this.bannerImg = this.community.banner_img;
                }
                else {
                    this.bannerImg = "img/1500_300_com_channel_default.png"
                }
                if (this.community.profile_img) {
                    this.profileImg = this.community.profile_img;
                }
                else {
                    this.profileImg = 'img/100_100_com_profile_default.png'
                }
            })
            .catch((err: any) => {
                console.log(err)
            })

    }
    reFetch(){
        this.fetch();
    }



    setting() {
        // (this.$refs.dropbox as HTMLElement).click();
    }

    currPage(routeName: string, query?: string) {

        let result = '';
        if ((routeName === this.$route.name) && Object.keys(this.$route.query).length === 0) {
            result = 'active'
        }
        else if (this.$route.query.media === query) {
            result = 'active'
        }

        return result;
    }

    movePage(router: string) {
        if (router === 'members') this.$router.push(`/${this.$i18n.locale}/community/${this.community.id}/members`)
        else if (router === 'timeline') this.$router.push(`/${this.$i18n.locale}/community/${this.community.id}/timeline`)
    }
}
